"use strict";

angular.module("vendor")
.component("groupAuthorizedCustomerManageSection", {
    bindings: {
        catalog: "=",
        membership: "="
    },
    templateUrl: require("./group-manage-section.component.html"),
    controllerAs: "GroupManageSectionCtrl",
    controller: controller
});

function controller(
    $scope, $controller, ModalService, CatalogSharingGroupAuthorizedManageCustomer, PartnershipStatusFilterService,
    PartnershipTagService, ActionFactory, CatalogSharingGroupPartnershipAddCustomer, APPROVAL_GROUP_STRATEGY
) {
    angular.extend(this, $controller("AbstractCatalogGroupAuthorizedCustomer", {$scope: $scope}));
    var _this = this;
    var currentSort;
    $scope.membership = _this.membership;
    $scope.APPROVAL_GROUP_STRATEGY = APPROVAL_GROUP_STRATEGY;

    if ($scope.membership.can_invite_to_group && $scope.membership.group.approval_membership_strategy === APPROVAL_GROUP_STRATEGY.AUTOMATIC) {
        $scope.service = CatalogSharingGroupPartnershipAddCustomer;
    }
    var actionService = new ActionFactory($scope.service);

    $scope.groupLinkId = _this.catalog.group_link_id;
    $scope.groupAuthorizedManageCustomerFactory = CatalogSharingGroupAuthorizedManageCustomer;
    this.searchTerm = "";
    $scope.pagination = {};
    $scope.filters = {};
    $scope.statusFilterService = PartnershipStatusFilterService;
    $scope.tagFilterService = PartnershipTagService;
    $scope.statusesValues = $scope.statusFilterService.query({statuses: "disabled,invited,valid,has_ordered"});
    $scope.APPROVAL_GROUP_STRATEGY = APPROVAL_GROUP_STRATEGY;

    $scope.$on("statusDateFilterUpdated", function(event, statusFilter) {
        $scope.authorizedPartnershipForm.$setDirty(statusFilter.status); // Avoid the list to be hidden when no results
        angular.extend($scope.filters, statusFilter);
        _this.clearSelection();
    });

    $scope.tagFilterParameter = {catalog_group_link: $scope.groupLinkId};
    $scope.$on("tagFilterUpdated", function(event, tagsFilter) {
        angular.extend($scope.filters, tagsFilter);
        _this.clearSelection();
    });

    this.updateAuthorizedState = function(instance) {
        $scope.service.updateState(instance.authorized_group_customer_id, instance.enabled)
        .then(function onSuccess(data) {
            instance.status = data.status;
            instance.last_disabled = data.last_disabled;
        }).finally(function() {
            $scope.$emit("refreshCatalogSharingType", "authorized");
            $scope.$emit("updatePopulationCount");
        });
    };

    this.onDeleteAuthorized = function() {
        $scope.$emit("refreshCatalogSharingType", "authorized");
        $scope.$emit("updatePopulationCount");
        _this.resetListings();
    };

    this.onUpdateSort = function(sort) {
        currentSort = sort;
        _this.query();
    };

    this.resetListings = function() {
        $scope.$emit("requestResetListing");
    };

    $scope.$on("resetListing", function($event) {
        $scope.filters.tags = null;
        $scope.$broadcast("queryFilter");
        _this.query();
    });

    this.refreshOnBulkAction = function() {
        this.resetListings();
        $scope.$emit("refreshCatalogSharingType", "authorized");
        $scope.$emit("updatePopulationCount");
    };

    this.sendSingleReminder = function(instance) {
        actionService.submitSingleAction("send_reminder", instance.id, $scope.groupLinkId).then(_this.search);
    };

    this.query = function() {
        var search = this.searchTerm;
        var page = $scope.pagination.current_page;

        $scope.service.queryAuthorized($scope.groupLinkId, search, page, currentSort, $scope.filters).$promise.then(
            function onSuccess(data) {
                $scope.setCheckboxState(data, $scope);
                $scope.pagination = data.pagination;
                $scope.instances = data.results;

                if ($scope.instances.length === 0) {
                    $scope.$emit("updateWizardMenu");
                }
            });
    };

    this.updateSelection = function(selected) {
        var search = this.searchTerm;
        var page = $scope.pagination.current_page;

        $scope.service.updateAuthorizedAllSelected($scope.groupLinkId, search, selected, currentSort, page, $scope.filters)
        .$promise.then(function onSuccess(data) {
            $scope.instances = data.results;
            $scope.setCheckboxState(data, $scope);
        });
    };

    this.clearSelection = function() {
        $scope.service.updateAuthorizedAllSelected($scope.groupLinkId, undefined, false, undefined, 1, {})
        .$promise.then(function onSuccess() {
            _this.query();
        });
    };

    $scope.$on("clearSelection", function() {
        _this.clearSelection();
    });

    this.selectSingle = function(instance) {
        $scope.updateSingle(instance, $scope.service.updateAuthorizedSingleSelected, $scope);
    };

    $scope.$on("fetchGroupLink", function(event, groupLinkId) {
        $scope.groupLinkId = groupLinkId;
        _this.query();
        $scope.tagFilterParameter.catalog_group_link = $scope.groupLinkId;
    });

    _this.clearSelection();
}



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/group-authorized-customer/group-manage-section/group-manage-section.component.js
// module id = 964
// module chunks = 0